"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnhancedMenu = EnhancedMenu;
var _lodash = require("lodash");
var React = _interopRequireWildcard(require("react"));
var _cardLevel = require("../../common/cardLevel");
var _paddingLevel = require("../../common/paddingLevel");
var _IconButton = require("../button/IconButton");
var _Card = require("../card/Card");
var _InputGroup = require("../forms/InputGroup");
var _iconNames = require("../icon/iconNames");
var _Menu = require("./Menu");
var _MenuDivider = require("./MenuDivider");
var _MenuHeader = require("./MenuHeader");
var _MenuItem = require("./MenuItem");
var _excluded = ["items", "searchable"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function EnhancedMenu(_ref) {
  var items = _ref.items,
    searchable = _ref.searchable,
    menuProps = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React.useState(items),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    filteredItems = _React$useState2[0],
    setFilteredItems = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    searchQuery = _React$useState4[0],
    setSearchQuery = _React$useState4[1];
  React.useEffect(function () {
    if (searchQuery) {
      setFilteredItems(items.filter(function (item) {
        var _item$headerText;
        var normalizedText = item.text.toLowerCase();
        var normalizedHeaderText = (_item$headerText = item.headerText) === null || _item$headerText === void 0 ? void 0 : _item$headerText.toLowerCase();
        var normalizedQuery = searchQuery.toLowerCase();
        var textMatches = "".concat(normalizedText).indexOf(normalizedQuery) >= 0;
        var headerTextMatches = "".concat(normalizedHeaderText).indexOf(normalizedQuery) >= 0;
        return textMatches || headerTextMatches;
      }));
    } else {
      setFilteredItems(items);
    }
  }, [searchQuery]);

  /**
   * We decided to make this search the header text as well on the assumption that because
   * it's visible then it should be searchable
   */
  function handleChange(event) {
    setSearchQuery(event.currentTarget.value);
  }
  function handleClear() {
    setSearchQuery('');
  }
  var clearIcon = searchQuery.length > 0 ? /*#__PURE__*/React.createElement(_IconButton.IconButton24, {
    icon: _iconNames.IconNames8.CROSS,
    onClick: handleClear,
    tagName: "span",
    "aria-label": "Clear"
  }) : undefined;

  /**
   * Using a card ensures that we retain the right color background even if we have to fudge the padding a little
   */
  return /*#__PURE__*/React.createElement(React.Fragment, null, searchable ? /*#__PURE__*/React.createElement(_Card.Card, {
    paddingLevel: _paddingLevel.PaddingLevel.COMPRESSED,
    level: _cardLevel.CardLevel.NONE,
    cardInnerProps: {
      style: {
        padding: '8px 8px 0 8px'
      }
    }
  }, /*#__PURE__*/React.createElement(_InputGroup.InputGroup, {
    placeholder: "Search...",
    leftIcon: _iconNames.IconNames16.MAGNIFYING_GLASS,
    onChange: handleChange,
    rightElement: clearIcon,
    value: searchQuery
  })) : null, /*#__PURE__*/React.createElement(EnhancedMenuItemsRenderer, {
    items: filteredItems,
    menuProps: menuProps
  }));
}
function EnhancedMenuItemsRenderer(_ref2) {
  var items = _ref2.items,
    menuProps = _ref2.menuProps;
  var groupedItems = (0, _lodash.groupBy)(items, 'headerText');
  var headers = Object.keys(groupedItems);

  /**
   * Tried typing this to (MenuDivider | MenuItem | MenuHeader)[] but it was moaning
   * and I couldn't work out why
   */
  var menuChildren = [];

  /**
   * Lodash will group anything without `headerText` under the string of "undefined"
   */
  var hasHeaders = !headers.every(function (header) {
    return header === 'undefined';
  });
  function addMenuItems(itemsToAdd) {
    itemsToAdd.forEach(function (item) {
      var handleClick = function handleClick() {
        if (item.onClick) {
          item.onClick(item);
        }
      };
      var menuItemProps = (0, _lodash.omit)(item, 'headerText', 'onClick', 'value');
      menuChildren.push(/*#__PURE__*/React.createElement(_MenuItem.MenuItem, _extends({
        key: "".concat(item.headerText, ".").concat(item.text)
      }, menuItemProps, {
        onClick: handleClick
      })));
    });
  }

  /**
   * If we have any headers provided then we want to group the items
   * If not then we display them ungrouped
   */
  if (hasHeaders) {
    Object.keys(groupedItems).forEach(function (headerText) {
      var headerTextToShow = headerText === 'undefined' ? 'Ungrouped' : headerText;
      menuChildren.push(/*#__PURE__*/React.createElement(_MenuHeader.MenuHeader, {
        key: headerTextToShow,
        text: headerTextToShow
      }));
      addMenuItems(groupedItems[headerText]);
      if (headerText !== (0, _lodash.last)(headers)) {
        menuChildren.push(/*#__PURE__*/React.createElement(_MenuDivider.MenuDivider, {
          key: "".concat(headerTextToShow, " - Divider")
        }));
      }
    });
  } else {
    addMenuItems(items);
  }
  return /*#__PURE__*/React.createElement(_Menu.Menu, menuProps, menuChildren);
}